// src/services/cofounder/tools/dataTools.js
import { registerTool } from './ToolRegistry';
import { fetchContextData, formatContextData } from '../../../utils/dataFetcher';

export function registerDataTools() {
  registerTool({
    name: 'fetchSalesData',
    description: 'Fetch sales data for a given time period. Returns sales records with totals and breakdowns.',
    category: 'read',
    requiresConfirmation: false,
    parameters: {
      type: 'object',
      properties: {
        timePeriod: {
          type: 'string',
          enum: ['today', 'yesterday', 'this_week', 'last_week', 'this_month', 'last_month', 'this_quarter', 'this_year', 'all_time'],
          description: 'Time period to fetch sales for'
        }
      },
      required: ['timePeriod']
    },
    execute: async (args, context) => {
      const data = await fetchContextData(args.timePeriod, ['sales'], context.userProfile, context.activeBusiness);
      return formatContextData(data);
    }
  });

  registerTool({
    name: 'fetchInventoryData',
    description: 'Fetch current inventory/stock items. Returns item details, stock levels, low stock alerts.',
    category: 'read',
    requiresConfirmation: false,
    parameters: {
      type: 'object',
      properties: {},
      required: []
    },
    execute: async (args, context) => {
      const data = await fetchContextData('all_time', ['inventory'], context.userProfile, context.activeBusiness);
      return formatContextData(data);
    }
  });

  registerTool({
    name: 'fetchCustomerData',
    description: 'Fetch customer records. Returns customer list with segmentation and status.',
    category: 'read',
    requiresConfirmation: false,
    parameters: {
      type: 'object',
      properties: {},
      required: []
    },
    execute: async (args, context) => {
      const data = await fetchContextData('all_time', ['customers'], context.userProfile, context.activeBusiness);
      return formatContextData(data);
    }
  });

  registerTool({
    name: 'fetchFinancialData',
    description: 'Fetch financial transactions for a time period. Returns income, expenses, cash flow.',
    category: 'read',
    requiresConfirmation: false,
    parameters: {
      type: 'object',
      properties: {
        timePeriod: {
          type: 'string',
          enum: ['today', 'yesterday', 'this_week', 'last_week', 'this_month', 'last_month', 'this_quarter', 'this_year', 'all_time'],
          description: 'Time period to fetch financial data for'
        }
      },
      required: ['timePeriod']
    },
    execute: async (args, context) => {
      const data = await fetchContextData(args.timePeriod, ['finances'], context.userProfile, context.activeBusiness);
      return formatContextData(data);
    }
  });

  registerTool({
    name: 'fetchOrderData',
    description: 'Fetch orders for a time period. Returns order list with status and totals.',
    category: 'read',
    requiresConfirmation: false,
    parameters: {
      type: 'object',
      properties: {
        timePeriod: {
          type: 'string',
          enum: ['today', 'yesterday', 'this_week', 'last_week', 'this_month', 'last_month', 'this_quarter', 'this_year', 'all_time'],
          description: 'Time period to fetch orders for'
        }
      },
      required: ['timePeriod']
    },
    execute: async (args, context) => {
      const data = await fetchContextData(args.timePeriod, ['orders'], context.userProfile, context.activeBusiness);
      return formatContextData(data);
    }
  });

  registerTool({
    name: 'fetchEmployeeData',
    description: 'Fetch employee/team member records. Returns employee list with departments.',
    category: 'read',
    requiresConfirmation: false,
    parameters: {
      type: 'object',
      properties: {},
      required: []
    },
    execute: async (args, context) => {
      const data = await fetchContextData('all_time', ['employees'], context.userProfile, context.activeBusiness);
      return formatContextData(data);
    }
  });

  registerTool({
    name: 'fetchBusinessDetails',
    description: 'Fetch details about the current business including name, industry, type, location.',
    category: 'read',
    requiresConfirmation: false,
    parameters: {
      type: 'object',
      properties: {},
      required: []
    },
    execute: async (args, context) => {
      const data = await fetchContextData('all_time', ['business'], context.userProfile, context.activeBusiness);
      return formatContextData(data);
    }
  });
}
